import React, { Component } from 'react';
import GameComponent from './board/GameComponent';
import 'bootstrap-css-only';
import axios from 'axios';
import { hashCode } from './tools';
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledTooltip,
    Button, Table, CustomInput,
    Modal, ModalHeader, ModalBody, ModalFooter,
    Input, Label,
    Row, Container, Col 
    } from 'reactstrap';

 
export default class GamesContainer extends Component {

    constructor(props) {
        super(props);
        this.elementWidth = 360;
        this.navbarWidth = (this.elementWidth * 3) + 30;

        this.toggleVisibleGame = this.toggleVisibleGame.bind(this);
        this.toggleShowHideAllGames = this.toggleShowHideAllGames.bind(this);
        this.toggleModalVisible = this.toggleModalVisible.bind(this);
        this.navbarToggle = this.navbarToggle.bind(this);
        this.downloadPDNFile = this.downloadPDNFile.bind(this);
        this.toggleEditGamesModalVisible = this.toggleEditGamesModalVisible.bind(this);
        this.editGamesModalAccept = this.editGamesModalAccept.bind(this);
        this.toggleEditGamesModalCancel = this.toggleEditGamesModalCancel.bind(this);

        let gamesEnabled = [];
        for(let i = 0; i < props.gamesData.length; i++) {
            const game = props.gamesData[i];
            if (this.props.showGamesOnlyWithMoves) {
                let checkMovesText = /(\d+.[\sa-hA-H0-9x\-.\\r\\n/]*)/g.exec(game.pdn);
                gamesEnabled[i] = checkMovesText != null;
            } else {
                gamesEnabled[i] = true;
            }
        }
        const pwdData = JSON.parse(localStorage.getItem('gep_dap') || '{}');
        let pwd = '';
        if (this.props.settingsData !== undefined) {
            pwd = pwdData[this.props.settingsData.dapTournamentKey];
        }
        this.state = {
            dialogShowHide_visible: false,
            dialogShowHide_showHideAllCheckboxChecked: true,
            gamesEnabled: gamesEnabled,
            navbarIsOpen: false,
            dialogEditGames_visible: false,
            gamesPasssword: pwd,
        }

    }

    componentDidMount(){
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    navbarToggle() {
        
        this.setState({
            navbarIsOpen: !this.state.navbarIsOpen
        });
    }


    toggleVisibleGame(id) {
        let gamesEnabled = [...this.state.gamesEnabled];
        gamesEnabled[id] = !gamesEnabled[id];
        this.setState({
            gamesEnabled:gamesEnabled
        })
    }

    toggleShowHideAllGames() {
        const showHideAllCheckboxChecked = !this.state.dialogShowHide_showHideAllCheckboxChecked;
        let gamesEnabled = [...this.state.gamesEnabled];

        for (let i = 0; i<gamesEnabled.length; i++) {
            gamesEnabled[i] = showHideAllCheckboxChecked;
        }

        this.setState({
            gamesEnabled:gamesEnabled,
            dialogShowHide_showHideAllCheckboxChecked: showHideAllCheckboxChecked
        })
    }

    toggleModalVisible() {
        this.setState({
            dialogShowHide_visible: !this.state.dialogShowHide_visible
        });
    }

    toggleEditGamesModalVisible() {
        this.setState({
            dialogEditGames_visible: !this.state.dialogEditGames_visible
        });
    }

    editGamesModalAccept() {
        if (this.props.settingsData === undefined) {
            return;
        }
        const pwdData = JSON.parse(localStorage.getItem('gep_dap') || '{}');
        pwdData[this.props.settingsData.dapTournamentKey] = this.state.gamesPasssword;
        localStorage.setItem('gep_dap', JSON.stringify(pwdData));
        window.location.reload();
        /*
        this.setState({
            dialogEditGames_visible: false
        });
        this.props.settingsData.reloadSettings();
        */
    }
    
    toggleEditGamesModalCancel() {
        this.setState({
            dialogEditGames_visible: false,
            gamesPasssword: ''
        });
    }

   
    downloadPDNFile() {
        axios.get(this.props.getGamesUrl)
            .then(res => {
                if ( !this.mounted ) return;
                const gamesData = res.data;
                if (Array.isArray(gamesData)) {
                    let pdns = []
                    for (let i = 0; i<gamesData.length; i++) {
                        let pdn = gamesData[i].pdn.replace(/\\r/,'')
                        pdn = pdn.replace(/\\n/g,'\n')
                        pdn = pdn.replace(/\\"/g,'"')
                        pdn = pdn.replace(/\"/g,'"')
                        pdns.push(pdn);
                    }
                    const FileSaver = require('file-saver');
                    const blob = new Blob([pdns.join("\n")], {type: "text/plain;charset=utf-8"});
                    FileSaver.saveAs(blob, "games.pdn");
                }
            })
            .catch(err => {
                console.error(err);
            })
        
    }
    


    renderModalShowHideGames() {
        let enabledGamesRows = [];

  
        if (this.props.gamesData) {
            let cells = [];
            this.gameHide = [];
            for(let i = this.props.gamesData.length-1; i >=0 ; i--) {
                const game = this.props.gamesData[i];
                const gameLabel = game.whiteName + "-" + game.blackName;
                const id = i;
                cells.push(
                    <td key={"gameHideTd" + id}><CustomInput onClick={()=>this.toggleVisibleGame(id)} id={"gameHide"+id} 
                        checked={this.state.gamesEnabled[id]} type="checkbox" label={gameLabel} /></td>
                )
                if (((this.props.gamesData.length-i) % 2 === 0 && i > 0) || i === 0) {
                    enabledGamesRows.push(
                        <tr key={"modal_tr" + i}>
                            {cells}
                        </tr>
                    )
                    cells = [];
                }
            }
        }
        return (

            <div key="modal_div1">
                <Modal size="lg" isOpen={this.state.dialogShowHide_visible} 
                    toggle={this.toggleModalVisible} className={this.props.className}>
                    <ModalHeader toggle={this.toggleModalVisible}>Show/hide games</ModalHeader>
                    <ModalBody>
                    <CustomInput  onClick={() => this.toggleShowHideAllGames()} id="all" 
                        checked={this.state.dialogShowHide_showHideAllCheckboxChecked} 
                        type="checkbox" label="Hide/Show all" /><br />
                    <div style={{width:'100%', height: "400px", overflowY: 'scroll' }}>
                        <Table>
                            <tbody>
                                {enabledGamesRows}
                            </tbody>
                        </Table>
                    </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggleModalVisible}>Close</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }

    renderModalEditGames() {
        return (
            <div key="modal_div2">
                <Modal size="sm" isOpen={this.state.dialogEditGames_visible} 
                    toggle={this.toggleEditGamesModalVisible} className={this.props.className}>
                    <ModalHeader toggle={this.toggleEditGamesModalVisible}>Edit games password</ModalHeader>
                    <ModalBody>
                        <div style={{width:'100%' }}>
                            <Label for="exampleEmail">
                                Enter edit games password
                            </Label>
                            <Input
                                name="editGamesPassword"
                                value={this.state.gamesPasssword}
                                id="editGamesPassword"
                                placeholder="Edit games password"
                                onChange={(e) => {
                                    this.setState({ gamesPasssword: e.target.value });
                                }}
                            />
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.editGamesModalAccept}>OK</Button>
                        <Button color="secondary" onClick={this.toggleEditGamesModalCancel}>Cancel</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }

    renderNavbar() {
        return(
            <div style={{width:this.navbarWidth}}>
            <Navbar key="navbar1" color="light" light expand="md">
            <NavbarBrand href={this.props.headerLink}>{this.props.header}</NavbarBrand>
            <NavbarToggler onClick={this.navbarToggle} />
            <Collapse isOpen={this.state.navbarIsOpen} navbar>
                <Nav className="ml-auto" navbar>
                    {this.props.navbarItems ? this.props.navbarItems : null}
                    {this.props.navbarClubItems ? this.props.navbarClubItems : null}
                    <NavItem>
                        <NavLink style={{ cursor: 'pointer' }} onClick={()=>this.toggleModalVisible()}>
                            <span id="id_show_hide_games" className="glyphicon glyphicon-eye-close"></span>
                                <UncontrolledTooltip placement="top" target="id_show_hide_games">
                                    Show/Hide games
                                </UncontrolledTooltip>
                        </NavLink>
                    </NavItem>
                    {this.props.getGamesUrl && this.props.settingsData && this.props.settingsData.downloadAllGamesEnable === '1' &&
                    <NavItem>
                        <NavLink style={{ cursor: 'pointer' }} onClick={()=>this.downloadPDNFile()}>
                              <span id="id_download_pdn" className="glyphicon glyphicon-download-alt"></span>
                                <UncontrolledTooltip placement="top" target="id_download_pdn">
                                    Download PDN file
                                </UncontrolledTooltip>
                        </NavLink>
                    </NavItem>}
                    {this.props.settingsData.enableEditGamePassword === '1' &&
                    <NavItem>
                        <NavLink style={{ cursor: 'pointer' }} onClick={()=>this.toggleEditGamesModalVisible()}>
                              <span id="id_edit_game_pwd" className="glyphicon glyphicon-pencil"></span>
                                <UncontrolledTooltip placement="top" target="id_edit_game_pwd">
                                    Enable edit games
                                </UncontrolledTooltip>
                        </NavLink>
                    </NavItem>}
                </Nav>
            </Collapse>
            </Navbar>
            </div>
        );
    }

    render() {
        let games = [];
 

        if (this.props.gamesData) {
            for(let i = this.props.gamesData.length-1; i >= 0 ; i--) {
                const game = this.props.gamesData[i];
                if (this.props.selectedClub) {
                    if (hashCode(game.whiteClub) != this.props.selectedClub && hashCode(game.blackClub) != this.props.selectedClub) {
                        continue;
                    }
                }
                if (this.state.gamesEnabled[i] === true) {
                    games.push(
                        <GameComponent 
                            key={"gameC" + game.id}
                            size={this.elementWidth} 
                            settingsData={this.props.settingsData} 
                            gameData={game} >
                        </GameComponent>
                    )
                } else {
                    games.push(null);
                }
            }
        }
        const maxWidth = this.props.settingsData && this.props.settingsData.subgames !== "0" ? {maxWidth:"99%"} : {maxWidth:"100%"};
        return (
            <div>
                <Container>
                    <Row>
                        {this.renderModalShowHideGames()}
                        {this.renderModalEditGames()}
                        {this.renderNavbar()}
                    </Row>
                    <Row style={maxWidth}>
                        {games}
                    </Row>
                </Container>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/GamesContainer.js